export const validateJSON = (jsonString: string): string | null => {
  if (!jsonString.trim()) {
    return null;
  }

  try {
    JSON.parse(jsonString);
    return null;
  } catch (error) {
    if (error instanceof Error) {
      return error.message;
    }
    return "Invalid JSON";
  }
};
